import React, { Component } from 'react';
import {Link} from 'react-router-dom';




class SubjectItem extends Component {

   constructor(props) {
    super(props);

    this.viewMarkSheet = this.viewMarkSheet.bind(this);

     this.state={
        
     }
  }

  

  viewMarkSheet()
  {
    this.props.viewMarkSheet(1, this.props.subject_details)
  }

  render() {
    const _this=this;

    return (
        <tr>
            <th className = "table-ms-content padded">{_this.props.subject_details.Class}</th>
            <th className = "table-ms-content padded">{_this.props.subject_details.Subject}</th>
            <th className = "table-ms-content padded ">{_this.props.subject_details.Names}</th>
            <td>
                <button type="button" rel="tooltip" onClick={_this.viewMarkSheet} title="" className="btn btn-danger btn-link btn-sm" data-original-title="View MarkSheet">
                        View MarkSheet
                </button>
            </td>
       </tr>


    );
  }




}

export default SubjectItem;